import Navbar from './Navbar';
import Footer from './Footer';

type LayoutProps = {
  children: React.ReactNode;
};

export default function Layout({ children }: LayoutProps) {
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#E6F7F4] to-[#C5E8E3]">
      <Navbar />
      <main className="pt-20">{children}</main>
      <Footer />
    </div>
  );
} 